export const AeQrCode = () => import(/* webpackChunkName: "qr-codes" */ './AeQrCode.vue');
export const QrCodeReader = () => import(/* webpackChunkName: "qr-codes" */ './QrCodeReader.vue');
